const detectOS = (userAgent) => {
  if (/Windows NT/i.test(userAgent)) return "Windows";
  if (/Mac OS X/i.test(userAgent)) return "macOS";
  if (/Android/i.test(userAgent)) return "Android";
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
  if (/Linux/i.test(userAgent)) return "Linux";
  return "unknown";
};

const detectBrowser = (userAgent) => {
  if (/Edg\//i.test(userAgent)) return "Edge";
  if (/Chrome\//i.test(userAgent) && !/Edg\//i.test(userAgent)) return "Chrome";
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) return "Safari";
  if (/Firefox/i.test(userAgent)) return "Firefox";
  return "unknown";
};

const detectDeviceType = (userAgent) => {
  if (/Mobi|Android|iPhone|iPod/i.test(userAgent)) return "mobile";
  if (/iPad|Tablet/i.test(userAgent)) return "tablet";
  return "desktop";
};

let cachedDeviceMetadata = null;

export const getClientDeviceMetadata = () => {
  if (cachedDeviceMetadata) return cachedDeviceMetadata;

  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {};
  }

  const userAgent = navigator.userAgent || "";
  const timezone =
    typeof Intl !== "undefined"
      ? Intl.DateTimeFormat().resolvedOptions().timeZone || ""
      : "";

  cachedDeviceMetadata = {
    os: detectOS(userAgent),
    browser: detectBrowser(userAgent),
    deviceType: detectDeviceType(userAgent),
    platform: navigator.platform || "",
    screen: {
      width: window.screen?.width || 0,
      height: window.screen?.height || 0,
    },
    language: navigator.language || "",
    timezone,
    userAgent,
  };

  return cachedDeviceMetadata;
};

export const resetClientDeviceMetadataCache = () => {
  cachedDeviceMetadata = null;
};

export default getClientDeviceMetadata;
